import { Layout as AntLayout, Breadcrumb, Button, Descriptions, Menu, PageHeader, Spin } from 'antd';
import dayjs from 'dayjs';
import React, { ReactElement, ReactNode, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, NavLink } from 'react-router-dom';
import { IGlobalState } from '~reducer';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import menuDivider from '~UI/menuDivider';
import { Dispatch } from 'redux';
import './prepaid-interest-sale-transfers.less';
import IWarehouseLoanTransactionAba from '~Api/WarehouseLoanTransactionAba/IWarehouseLoanTransactionAba';
import { abaSelector } from '~WarehouseLoanTransactionAbas/selectors';
import { abaGetAction } from '~WarehouseLoanTransactionAbas/actions';
import abaTypeLabels from '../abaTypeLabels';
import { Helmet } from 'react-helmet';

export default function Layout(props: {
    breadcrumb?: JSX.Element;
    children: JSX.Element | JSX.Element[];
    section: string;
    pageTitle: string;
    uuid: string;
}): ReactElement {
    const { breadcrumb, children, section, uuid, pageTitle } = props;

    const dispatch: Dispatch = useDispatch();

    const warehouseLoanTransactionAba: IWarehouseLoanTransactionAba = useSelector((state: IGlobalState) => abaSelector(state, uuid));

    useEffect(() => {
        if (!warehouseLoanTransactionAba) {
            dispatch(abaGetAction(uuid));
        }
    }, [
        dispatch,
        warehouseLoanTransactionAba,
        uuid,
    ]);

    if (!warehouseLoanTransactionAba) {
        return (
            <AntLayout className='loans'>
                <Breadcrumb className='breadcrumb'>
                    <Breadcrumb.Item>Home</Breadcrumb.Item>
                    <Breadcrumb.Item><Link to='/accounts'>Accounts</Link></Breadcrumb.Item>
                    <Breadcrumb.Item><Link to='/prepaid-interest-sale-transfers/'>Prepaid Interest Sale Transfers</Link></Breadcrumb.Item>
                </Breadcrumb>
                <Spin />
            </AntLayout>
        );
    }

    const breadcrumbBlock: JSX.Element = breadcrumb ? (
        <>
            <Breadcrumb.Item><Link to={`/prepaid-interest-sale-transfers/${warehouseLoanTransactionAba.uuid}`}>{dayjs(warehouseLoanTransactionAba.createdTime).format('DD/MM/YYYY HH:mm')}</Link></Breadcrumb.Item>
            {breadcrumb}
        </>
    ) : (
        <Breadcrumb.Item>{dayjs(warehouseLoanTransactionAba.createdTime).format('DD/MM/YYYY HH:mm')}</Breadcrumb.Item>
    );

    const extra: ReactNode = (
        <Button
            href={`${process.env.API_HOST}/warehouse-loan-transaction-abas/${warehouseLoanTransactionAba.uuid}/download`}
            target='_blank'
        >ABA File</Button>
    );

    const menuItems: ItemType[] = [
        {
            key: 'transactions',
            label: <NavLink to={`/prepaid-interest-sale-transfers/${warehouseLoanTransactionAba.uuid}/transactions`}>Transactions</NavLink>,
        },
        menuDivider,
        {
            key: 'history',
            label: <NavLink to={`/prepaid-interest-sale-transfers/${warehouseLoanTransactionAba.uuid}/history`}>History</NavLink>,
        },
    ];

    return (
        <AntLayout className='prepaid-interest-sale-transfer'>
            <Helmet>
                <title>{pageTitle}&nbsp;/&nbsp;{dayjs(warehouseLoanTransactionAba.createdTime).format('DD/MM/YYYY HH:mm')}</title>
            </Helmet>
            <Breadcrumb className='breadcrumb'>
                <Breadcrumb.Item>Home</Breadcrumb.Item>
                <Breadcrumb.Item><Link to='/accounts'>Accounts</Link></Breadcrumb.Item>
                <Breadcrumb.Item><Link to='/prepaid-interest-sale-transfers/'>Prepaid Interest Sale Transfers</Link></Breadcrumb.Item>
                {breadcrumbBlock}
            </Breadcrumb>
            <PageHeader
                className='header'
                extra={extra}
                ghost={false}
                title={`${dayjs(warehouseLoanTransactionAba.createdTime).format('DD/MM/YYYY HH:mm')}`}
            >
                <Descriptions size='small' column={5}>
                    <Descriptions.Item label='Destination'>{abaTypeLabels[warehouseLoanTransactionAba.abaType]}</Descriptions.Item>
                </Descriptions>
            </PageHeader>

            <AntLayout className='content-wrapper'>
                <AntLayout.Sider className='menu' theme='light' width={240}>
                    <Menu
                        defaultSelectedKeys={[ section ]}
                        items={menuItems}
                        mode='inline'
                    />
                </AntLayout.Sider>
                <AntLayout.Content className={`content ${section}`}>
                    {children}
                </AntLayout.Content>
            </AntLayout>
        </AntLayout>
    );
}
